import { lazy, Suspense } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const AsyncPhoneNumberContextProvider = /*#__PURE__*/lazy(() => import('calling-remote-app/calling-remote-dialer/common/context/PhoneNumberContext'));
export const AsyncCallingRemoteWrapper = /*#__PURE__*/lazy(() => import('./CallingRemoteWrapper'));
export const CallingRemoteWrapper = props => {
  const {
    callingOnboardingStatus,
    closeRemote,
    gates,
    hasCallingAccess,
    hasExternalFromNumbers,
    hasConnectFromNumbers,
    hasPortalFromNumbers,
    isHubSpotCallingEnabled,
    isRecordingEnabled,
    portalId,
    setCallingOnboarding,
    showConnectionErrorAlert,
    showConnectionDeprecatedAlert,
    showOfflineAlert,
    showLoadingSpinner,
    showCriticalErrorAlert,
    showMicrophoneErrorAlert,
    installedCallingSettings
  } = props;
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(AsyncPhoneNumberContextProvider, {
      children: /*#__PURE__*/_jsx(AsyncCallingRemoteWrapper, {
        closeRemote: closeRemote,
        callingOnboardingStatus: callingOnboardingStatus,
        gates: gates,
        hasCallingAccess: !!hasCallingAccess,
        hasExternalFromNumbers: hasExternalFromNumbers,
        hasConnectFromNumbers: hasConnectFromNumbers,
        hasPortalFromNumbers: hasPortalFromNumbers,
        isHubSpotCallingEnabled: !!isHubSpotCallingEnabled,
        isRecordingEnabled: !!isRecordingEnabled,
        portalId: portalId,
        setCallingOnboarding: setCallingOnboarding,
        showConnectionErrorAlert: showConnectionErrorAlert,
        showConnectionDeprecatedAlert: showConnectionDeprecatedAlert,
        showOfflineAlert: showOfflineAlert,
        showLoadingSpinner: showLoadingSpinner,
        showCriticalErrorAlert: showCriticalErrorAlert,
        showMicrophoneErrorAlert: showMicrophoneErrorAlert,
        installedCallingSettings: installedCallingSettings
      })
    })
  });
};